import React from "react";
import { useFormik } from 'formik';
import { validates } from './SSOValidation'
import { PageSubTitle } from "../../styled-components/shared";
import { useTranslation } from "react-i18next";
import Alert from "../../components/Alert";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import validURL from 'valid-url'
import Switch from "@material-ui/core/Switch";  // DLM-19585 - add a switch to control show/no show on mapping paramters
import { CLIENT_AUTH_TYPE } from '../../data/constants';
import { makeStyles } from "@material-ui/core";
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';

const PingFredForm = (props) => {
    const useChipInputHelperTextStyles = makeStyles(() => ({
        root: {
            marginBottom: '0px',
            marginLeft: '0px'
        }
    }))();

    const { t } = useTranslation();
    const {
        StyledChipInput,
        SubHeader,
        CustomAlertText,
        FlexRow,
        ButtonContainer,
        StyledTextField,
        MButton,
        CheckboxHolder,
        ButtonStyle,
        isLoading,
        dataBaseSSO,
        ssoTestStatus,
        SSOSettings,
        ssoSetting,
        config,
        globalAppSettings,
        SSO_CONSTANTS,
        sc,
        onChangeDeactivationSwitch,
        handleSSOTestConfig,
        handleSave,
        StyledChip
    } = props;
    const validate = validates(validURL, t);
    let isProviderPingId = (SSOSettings && SSOSettings.ssoProvider === 1)
    var vals= {
        webClientId: isProviderPingId ? SSOSettings.webClientId : '',
        webRedirectURI: isProviderPingId ?SSOSettings.webRedirectURI:config.WEB_REDIRECT_URI,
        androidClientId: isProviderPingId ? SSOSettings.androidClientId : '',
        androidRedirectURI: isProviderPingId ?SSOSettings.androidRedirectURI:config.ANDROID_REDIRECT_URI,
        enterpriseClientId:isProviderPingId ? SSOSettings.enterpriseClientId : '',
        enterpriseRedirectURI: isProviderPingId ?SSOSettings.enterpriseRedirectURI:config.ELS_REDIRECT_URI,
        authorizationURL: isProviderPingId ? SSOSettings.authorizationURL : '',
        tokenURL: isProviderPingId ? SSOSettings.tokenURL : '',
        userInfoURL: isProviderPingId ? SSOSettings.userInfoURL : '',  // DLM-20088
        introspectionURL: isProviderPingId ? SSOSettings.introspectionURL : '',
        revokeURL: isProviderPingId ? SSOSettings.revokeURL : '',
        logoutURL:isProviderPingId ? SSOSettings.logoutURL : '',
        //roleParam: SSOSettings ? SSOSettings.roleParam : '',
        adminRoleParam: isProviderPingId ? SSOSettings.adminRoleParam : '',
        managerRoleParam: isProviderPingId ? SSOSettings.managerRoleParam : '',
        adminRoles: isProviderPingId && SSOSettings.admin ? SSOSettings.admin : [],
        managerRoles:isProviderPingId && SSOSettings.manager ? SSOSettings.manager : [],
        userNameParam: isProviderPingId ? SSOSettings.userNameParam : '',
        authorizationScope: isProviderPingId ? SSOSettings.authorizationScope : '',
        siteNameParam: isProviderPingId ? SSOSettings.siteNameParam : '',
        ssoParameterMappingEnable: isProviderPingId ? SSOSettings.ssoParameterMappingEnable : false, //DLM-19585
        clientAuthType: isProviderPingId ? SSOSettings.clientAuthType : CLIENT_AUTH_TYPE.NONE, //DLM-20746: default: None
        enablePKCE: isProviderPingId && SSOSettings.enablePKCE ? SSOSettings.enablePKCE : false,
        ssoProvider:1
    }
    if(vals.clientAuthType===0){
        vals.enablePKCE=true;
    }
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: vals,
        validate,
        onSubmit: values => {
            console.log(values,'values')
            handleSSOTestConfig(values)
        },
    });

    

      const handleAddChip = (value, rolesArr, field)=>{       
        let arr = [...rolesArr, value]              
        formik.setFieldValue(field, arr)
      }

      const handleDeleteChip = (chip, rolesArr, field)=>{
        let arr = [...rolesArr].filter(el=>{
            return el!==chip
        })
        formik.setFieldValue(field, arr)
    }
    return <>
        <form noValidate onSubmit={formik.handleSubmit}>
            <FlexRow style={{
                textAlign: "Left",
                display: "flex",
                justifyContent: "flexStart",
                marginBottom:"20px"
            }}>
                <SubHeader>{t("ssoActivationStatus")}:</SubHeader>
                <div style={{ width: "78%" }}>
                    {SSOSettings.ssoLogin === true ? <Chip
                        label="Active"
                        variant="outlined"
                        style={{color:"green", height:"24px",}}
                    /> : <Chip
                        label="Inactive"
                        style={{border: "1px solid rgba(255, 134, 146, 1)",
                        height:"24px",
                        backgroundColor:"rgba(255, 240, 241, 1)"
                        }}
                        variant="outlined"
                    />}
                </div>
            </FlexRow>
            <div style={{ marginBottom:"15px" }} >
                <SubHeader>{t('authorizationGrantType')} : </SubHeader>
                <CheckboxHolder style={{ marginLeft: '24px'}} >
                    <Radio
                        checked={true}
                        color="colorPrimary"
                    />
                    <SubHeader>
                        { t('authorizationCode')}
                    </SubHeader>
                </CheckboxHolder>
            </div>

            <div style={{ marginBottom:"15px" }} >
            <SubHeader>{t('clientAuthType')}  : </SubHeader>
                <RadioGroup style={{ display:'flex',   flexDirection:'column', marginLeft:'32px' }} 
                        value={parseInt(formik.values.clientAuthType)}
                        onChange={(event) => {
                            formik.handleChange(event);
                            formik.setFieldValue('enablePKCE', parseInt(event.target.value) === 0 ? true : false);
                        }}                 
                        onBlur={formik.handleBlur('clientAuthType')}>
                        <FormControlLabel style={{marginBottom:'-5px', fontFamily:'IBM Plex Sans'}}  value={0} control={<Radio />}  name="clientAuthType" label={<SubHeader>{t('clientAuthTypeNone')}</SubHeader>} />
                        <FormControlLabel style={{marginBottom:'-5px', fontFamily:'IBM Plex Sans'}} value={3} control={<Radio />}  name="clientAuthType" label={<SubHeader>{t('clientAuthTypeTLS')}</SubHeader>} />
                </RadioGroup>   
            </div>
    
            <FlexRow>     
            <FormControlLabel 
                    control={
                        <Checkbox
                            color="colorPrimary"
                            disabled 
                            value={formik.values.enablePKCE}
                            onChange={formik.handleChange('enablePKCE')}      
                            checked={formik.values.enablePKCE}
                    />
                    }
                    label={<SubHeader style={{fontWeight:'400', fontSize:"15px"}}>{t('pckeLabel')}</SubHeader>}
                />
            </FlexRow>
            
            <FlexRow>
                <SubHeader>{t('authorizationScopeParam')}:</SubHeader>
            </FlexRow>
            <FlexRow>
                    <StyledTextField
                    variant="outlined"
                    error={formik.errors.authorizationScope && formik.touched.authorizationScope ? true : false}
                    onChange={formik.handleChange('authorizationScope')}
                    onBlur={formik.handleBlur('authorizationScope')}
                    value={formik.values.authorizationScope}
                    helperText={formik.errors.authorizationScope && formik.touched.authorizationScope
                        ? formik.errors.authorizationScope : null}
                    placeholder={t('enterAuthorizationScope')}
                />
            </FlexRow>
            <br />
            {ssoSetting.ssoLogin ? <PageSubTitle style={{ marginBottom:"15px"}}>{t('ssoEndpointURLS')}</PageSubTitle> : null}
            <FlexRow>
                <SubHeader>{t('authorizationEndpointURLS')}:</SubHeader>
            </FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                variant="outlined"
                    error={formik.errors.authorizationURL && formik.touched.authorizationURL ? true : false}
                    onChange={formik.handleChange('authorizationURL')}
                    onBlur={formik.handleBlur('authorizationURL')}
                    value={formik.values.authorizationURL}
                    helperText={formik.errors.authorizationURL && formik.touched.authorizationURL
                        ? formik.errors.authorizationURL : null}
                    placeholder={t('enterAndroidAuthorizationEndpointURLS')}
                />
            </FlexRow>
            <FlexRow><SubHeader>{t('tokenEndpointURL')}:</SubHeader></FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.tokenURL && formik.touched.tokenURL ? true : false}
                    onChange={formik.handleChange('tokenURL')}
                    onBlur={formik.handleBlur('tokenURL')}
                    value={formik.values.tokenURL}
                    helperText={formik.errors.tokenURL && formik.touched.tokenURL ? formik.errors.tokenURL : null}
                    placeholder={t('enterTheTokenEndpointURL')}
                />
            </FlexRow>   
            <FlexRow>
                <SubHeader>{t('introspectionURL')}:</SubHeader>
            </FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.introspectionURL && formik.touched.introspectionURL ? true : false}
                    onChange={formik.handleChange('introspectionURL')}
                    onBlur={formik.handleBlur('introspectionURL')}
                    value={formik.values.introspectionURL}
                    helperText={formik.errors.introspectionURL && formik.touched.introspectionURL
                        ? formik.errors.introspectionURL : null}
                    placeholder={t('enterTheIntrospectionURL')}
                />    
            </FlexRow>
            <FlexRow>
                <SubHeader>{t('revokeEndpointURL')}:</SubHeader>
            </FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.revokeURL && formik.touched.revokeURL ? true : false}
                    onChange={formik.handleChange('revokeURL')}
                    onBlur={formik.handleBlur('revokeURL')}
                    value={formik.values.revokeURL}
                    helperText={formik.errors.revokeURL && formik.touched.revokeURL ? formik.errors.revokeURL : null}
                    placeholder={t('enterTheRevokeEndpointURI')}
                />
            </FlexRow>
            <FlexRow>
                <SubHeader>{t('logoutEndpointURL')}:</SubHeader>
            </FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.logoutURL && formik.touched.logoutURL ? true : false}
                    onChange={formik.handleChange('logoutURL')}
                    onBlur={formik.handleBlur('logoutURL')}
                    value={formik.values.logoutURL}
                    helperText={formik.errors.logoutURL && formik.touched.logoutURL ? formik.errors.logoutURL : null}
                    placeholder={t('enterLogoutEndpointURL')}
                />
            </FlexRow>
            <FlexRow>
                <SubHeader>{t('userInfoEndpointURL')}:</SubHeader>
            </FlexRow>
            <FlexRow>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.userInfoURL && formik.touched.userInfoURL ? true : false}
                    onChange={formik.handleChange('userInfoURL')}
                    onBlur={formik.handleBlur('userInfoURL')}
                    value={formik.values.userInfoURL}
                    helperText={formik.errors.userInfoURL && formik.touched.userInfoURL ? formik.errors.userInfoURL : null}
                    placeholder={t('enterTheUserInfoEndpointURI')}
                />
            </FlexRow>
            <br />
            {ssoSetting.ssoLogin ? <PageSubTitle style={{ marginBottom:"15px"}}>{t('ssoEndPointParameters')} </PageSubTitle> : null}

            <FlexRow>
                <SubHeader>{t('userNameParam')}:</SubHeader>
            </FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.userNameParam && formik.touched.userNameParam ? true : false}
                    onChange={formik.handleChange('userNameParam')}
                    onBlur={formik.handleBlur('userNameParam')}
                    value={formik.values.userNameParam}
                    helperText={formik.errors.userNameParam && formik.touched.userNameParam
                        ? formik.errors.userNameParam : null}
                    placeholder={t('enterTheUserName')}
                />
            </FlexRow>
            <FlexRow>
            <FormControlLabel 
                    control={
                        <Checkbox disabled={formik.handleBlur('ssoParameterMappingEnable')}
                        onChange={formik.handleChange('ssoParameterMappingEnable')}
                        checked={formik.values.ssoParameterMappingEnable}
                    />
                    }
                    label={<SubHeader>{t('parameterMapping')}</SubHeader>}
                />
            </FlexRow>
            {!ssoSetting.ssoLogin === false && formik.values.ssoParameterMappingEnable === true ?
                <>
                <FlexRow><SubHeader>{t('siteName')}:</SubHeader></FlexRow>
                <FlexRow style={{marginBottom:"15px"}}> 
                    <StyledTextField
                    variant="outlined"
                    error={formik.errors.siteNameParam && formik.touched.siteNameParam ? true : false}
                    onChange={formik.handleChange('siteNameParam')}
                    onBlur={formik.handleBlur('siteNameParam')}
                    value={formik.values.siteNameParam}
                    helperText={formik.errors.siteNameParam && formik.touched.siteNameParam ? formik.errors.siteNameParam : null}
                    placeholder={t('enterSiteName')}
                />
                </FlexRow>
                <FlexRow> <SubHeader>{t('adminRoleParam')}:</SubHeader></FlexRow>
                <FlexRow style={{marginBottom:"15px"}}>
                    <StyledTextField
                    variant="outlined"
                    error={formik.errors.adminRoleParam && formik.touched.adminRoleParam ? true : false}
                    onChange={formik.handleChange('adminRoleParam')}
                    onBlur={formik.handleBlur('adminRoleParam')}
                    value={formik.values.adminRoleParam}
                    helperText={formik.errors.adminRoleParam && formik.touched.adminRoleParam ? formik.errors.adminRoleParam : null}
                    placeholder={t('enterTheRole')}
                />
                </FlexRow>
                <FlexRow><SubHeader>{t('adminRoles')}:</SubHeader></FlexRow>
                <FlexRow style={{marginBottom:"15px"}}>
                <StyledChipInput
                    chipRenderer={(el)=>{
                        return (
                        <StyledChip 
                            variant="outlined"
                            label={el.value}
                            onDelete={() => handleDeleteChip(el.value, formik.values.adminRoles, 'adminRoles')}
                            />)
                    }}
                    FormHelperTextProps={{
                        classes:{
                            root:useChipInputHelperTextStyles.root
                        }
                    }}
                    style={{display:'flex', width:'65%'}}
                    variant="outlined"
                    value={formik.values.adminRoles}
                    placeholder={t('adminRoles')}
                    alwaysShowPlaceholder={true}
                    error={formik.errors.adminRoles && formik.touched.adminRoles ? true : false}
                    helperText={formik.errors.adminRoles && formik.touched.adminRoles ? formik.errors.adminRoles : null}
                    onAdd={(chip) => handleAddChip(chip, formik.values.adminRoles, 'adminRoles')}   
                    onDelete={(chip) => handleDeleteChip(chip, formik.values.adminRoles, 'adminRoles')}       
                />
            </FlexRow>
            <FlexRow><SubHeader>{t('managerRoleParam')}:</SubHeader></FlexRow>
            <FlexRow style={{marginBottom:"15px"}}> 
            <StyledTextField
                    variant="outlined"
                    error={formik.errors.managerRoleParam && formik.touched.managerRoleParam ? true : false}
                    onChange={formik.handleChange('managerRoleParam')}
                    onBlur={formik.handleBlur('managerRoleParam')}
                    value={formik.values.managerRoleParam}
                    helperText={formik.errors.managerRoleParam && formik.touched.managerRoleParam ? formik.errors.managerRoleParam : null}
                    placeholder={t('enterTheRole')}
            />
            </FlexRow>
            <FlexRow><SubHeader>{t('managerRoles')}:</SubHeader></FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledChipInput
                    chipRenderer={(el)=>{
                        return (
                        <StyledChip 
                            variant="outlined"
                            label={el.value}
                            onDelete={() => handleDeleteChip(el.value, formik.values.managerRoles, 'managerRoles')}
                            />)
                    }}
                    
                    FormHelperTextProps={{
                        classes:{
                            root:useChipInputHelperTextStyles.root
                        }
                    }}                
                    style={{display:'flex', width:'65%'}}
                    variant="outlined"
                    alwaysShowPlaceholder={true}
                    placeholder={t('managerRoles')}
                    value={formik.values.managerRoles}
                    error={formik.errors.managerRoles && formik.touched.managerRoles ? true : false}
                    helperText={formik.errors.managerRoles && formik.touched.managerRoles ? formik.errors.managerRoles : null}
                    onAdd={(chip) => handleAddChip(chip, formik.values.managerRoles, 'managerRoles')}   
                    onDelete={(chip) => handleDeleteChip(chip, formik.values.managerRoles, 'managerRoles')}       
                />
            </FlexRow>
            
            </> 
            :
            ''}
            <br />
            {ssoSetting.ssoLogin ? <PageSubTitle style={{ marginBottom:"15px"}}>{t('webPortal')}</PageSubTitle> : null}
            <FlexRow><SubHeader>{t('clientID')}:</SubHeader></FlexRow>
            <FlexRow style={{marginBottom:"15px"}}>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.webClientId && formik.touched.webClientId ? true : false}
                    onChange={formik.handleChange('webClientId')}
                    onBlur={formik.handleBlur('webClientId')}
                    value={formik.values.webClientId}
                    helperText={formik.errors.webClientId && formik.touched.webClientId ? formik.errors.webClientId : null}
                    placeholder={t('enterWebClientID')}
                />
            </FlexRow>
            <FlexRow> <SubHeader>{t('webRedirectURI')}:</SubHeader></FlexRow>  
            <FlexRow>
                <StyledTextField
                    variant="outlined"
                    error={formik.errors.webRedirectURI && formik.touched.webRedirectURI ? true : false}
                    onChange={formik.handleChange('webRedirectURI')}
                    onBlur={formik.handleBlur('webRedirectURI')}
                    value={formik.values.webRedirectURI}
                    helperText={formik.errors.webRedirectURI && formik.touched.webRedirectURI
                        ? formik.errors.webRedirectURI : null}
                    placeholder={t('enterTheWebRedirectURI')}
                />
            </FlexRow>
            
            <br />
            <br />
            <ButtonContainer>
                {ssoSetting.ssoLogin ? <MButton
                    style={
                        ButtonStyle, { marginRight: 10 }
                    }
                    disabled={isLoading}
                    variant="contained"
                    color="primary"
                    type="submit"
                >
                    {t('testSSO')}
                </MButton> : null}
                {ssoSetting.ssoLogin && ssoTestStatus === 1 && !dataBaseSSO ? <MButton
                    style={
                        isLoading ? { opacity: "0.7", ...ButtonStyle } : ButtonStyle, { marginRight: 10 }
                    }
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    type="button"
                >
                    {t('activeSSO')}
                </MButton> : null}
                {dataBaseSSO ? <MButton
                    style={
                        ButtonStyle
                    }
                    onClick={() => onChangeDeactivationSwitch(false)}
                    disabled={isLoading}
                    variant="contained"
                    color="primary"
                    type="button"
                >
                    {t('deactivate')}
                </MButton> : null}
            </ButtonContainer>
            <FlexRow
                style={{
                    display: "flex",
                    marginTop: 20
                }}
            >
                {/* <Alert severity="info">
                    <CustomAlertText> {t('asteriskMarkAlertMsg')}</CustomAlertText>
                </Alert> */}
            </FlexRow>
        </form>
    </>
}
export default PingFredForm;